import Vue from 'vue';
import Vuex from 'vuex';
import admin from '../module_admin/store';
import user from '../module_user/store';
import b2bUser from '../module_b2b_users/store';
import b2bClient from '../module_clients/store';
import api from '../module_user/api/api';
import {MESSAGES} from '@/module_user/uitls/messages';
import router from '@/router';
import defaultUser from "@/module_user/defaultUser.json";
import fitClient from "../clients/module_fit_summit/store";
import campaign from "@/module_campaign/store";
import social from "@/module_social/store";
import dashboard from "@/module_dashboard/store";
import themes from "@/store/themes";
import axios from "axios";
import defaultRoutes from "@/utils/defaultRoutes";
import {omit} from "lodash"
import Swal from "sweetalert2";
let baseUrl = process.env.VUE_APP_API_URL;
Vue.use(Vuex);

const strict = process.env.NODE_ENV !== 'production';

const getState = () => {
  return {
    userInfo: JSON.parse(localStorage.getItem("userInfo")),
    menuItems: JSON.parse(localStorage.getItem("menuItems")),
    loginError: null,
    signUpError: null,
    promoCodeError: null,
    accessCodeError: null,
    resetError: null,
    samePasswordError: null,
    loggingIn: false,
    signingUp: false,
    resetInstructionsSent: false,
    refreshTask: null,
    tokenRefreshing: false,
    passwordResetSuccessful: false,
    signUpSuccessful: false,
    tenantList: [],
    selectedTenant: 0,
    dashboardLoading: false,
    freeVideos: null,
    showClose: null,
    burgerMenu: false,
    fullscreen: false,
    defaultLandingPage: defaultRoutes.getDefaultLandingPage(),
    showAccessOptions: null,
    fcmToken : null,
    unreadCount : 0,
    activePopup: null,
    slowConnection: false,
    ADMIN_PORTAL_URL: process.env.VUE_APP_ADMIN_PORTAL_URL
  }
}

let store = new Vuex.Store({
  state: getState(),
  mutations: {
    setSlowConnection(state, isTrue) {
      state.slowConnection = isTrue;
    },
    setActivePopup(state, popup) {
      state.activePopup = popup;
    },
    removeActivePopup(state) {
      state.activePopup = null;
    },
    loggedIn(state, data) {
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      state.loginError = null;
    },
    setUserInfo(state, data) {
      if (Object.entries(data).length != 0) {
        localStorage.setItem('userInfo', JSON.stringify(data));
        state.userInfo = data;
        state.defaultLandingPage = defaultRoutes.getDefaultLandingPage()
      }
    },
    setMenuItem(state, menu) {
      state.menuItems = menu;
      localStorage.setItem('menuItems', JSON.stringify(menu));
    },
    setLoginError(state, error) {
      state.loginError = error;
    },
    setFCMToken(state, token) {
      state.fcmToken = token;
    },
    setUnreadCount(state,count) {

      if(typeof count === 'number'){
        state.unreadCount = count;
      }
      else{
        state.unreadCount = state.unreadCount + 1;
      }

    },
    setSignUpError(state, error) {
      state.signUpError = error;
    },
    setPromoCodeError(state, error) {
      state.promoCodeError = error;
    },
    setAccessCodeError(state, error) {
      state.accessCodeError = error;
    },
    loggingIn(state, loggingIn) {
      state.loggingIn = loggingIn;
    },
    signingUp(state, signingUp) {
      state.signingUp = signingUp;
    },
    setResetInstructions(state, sent) {
      state.resetInstructionsSent = sent;
    },
    setPasswordReset(state, success) {
      state.passwordResetSuccessful = success;
      if (success) {
        setTimeout(() => {
          router.push("/ef/sign-in");
          state.resetInstructionsSent = false;
        }, 4000);
      }
    },
    signUpSuccess(state, success) {
      state.signUpSuccessful = success;
      if (success) setTimeout(() => {
        router.push("/ef/sign-in");
        state.resetInstructionsSent = false;
      }, 4000);
    },
    setResetError(state, error) {
      state.resetError = error;
    },
    refreshTask(state, task) {
      state.refreshTask = task;
    },
    setTokenRefreshing(state, refreshing) {
      state.tokenRefreshing = refreshing;
    },
    passwordChanged(state, passwordChanged) {
      state.userInfo.passwordChanged = passwordChanged;
    },
    logout(state) {
      Object.assign(state, omit(getState(),["fcmToken"]));
    },
    tenantList(state, tenants) {
      state.tenantList = tenants;
    },
    setSelectedTenant(state, selectedTenant) {
      state.selectedTenant = selectedTenant;
    },
    setLoading(state, loading) {
      state.dashboardLoading = loading;
    },
    setFreeVideos(state, videos) {
      state.freeVideos = videos;
    },
    setCloseOnHeader(state, data) {
      state.showClose = data;
    },
    openBurgerMenu(state) {
      state.burgerMenu = true;
    },
    closeBurgerMenu(state) {
      state.burgerMenu = false;
    },
    setFullscreen(state, showFullscreen) {
      state.fullscreen = showFullscreen;
    },
    setShowAccessOptions(state, tenantInfo) {
      state.showAccessOptions = tenantInfo ?? null;
    }
  },
  getters: {
    getRole(state) {
      return state.userInfo ? state.userInfo.roles : []
    },
    isAdmin(state) {
      return state.userInfo && state.userInfo.role && state.userInfo.privileges.includes('access-admin-screen')
    },
    freeVideos(state) {
      return state.freeVideos;
    },
    useNewAdmin(state) {
      const config = state.userInfo?.corporate?.config || {};

      // If useOldAdmin is explicitly false or undefined
      if (config.useOldAdmin) {
        // If oldAdminEndTime exists and expired, use new admin
        if (config.oldAdminEndTime) {
          const endTime = new Date(config.oldAdminEndTime).getTime();
          if (Date.now() > endTime) {
            // expired
            return true;
          } else {
            // If useOldAdmin is true, fall back to localStorage flag
            return Boolean(localStorage.getItem("useNewAdminPortal"));
          }
        }
        // If useOldAdmin is true, fall back to localStorage flag
        return false;
      }
      // default to new admin
      return true;
    }


  },
  actions: {
    trackInGA({}, data = {}) {
      if (typeof window.gtag === "function") {
        const userInfo = store.state.userInfo || {};
        let eventName = 'end_users';
        let payload = {
          event_category: data.event_category || 'Start Workout',
          user_id: userInfo?.userId
        };

        if (Boolean(userInfo.corporate)) {
          eventName = userInfo.corporate.redirect_url || 'unknown_corporate';
          payload.corporate_name = userInfo.corporate.name;
          payload.corporate_id = userInfo.corporate.tenant_id;
        } else {
          eventName = 'end_users';
          payload.anonymous = Boolean(userInfo.isAnonymousUser);
        }
        payload = Object.assign({}, payload, data);
        eventName = data.event_name || eventName;

        window.gtag("event", eventName, payload);
      } else {
        console.error("Google Analytics is not initialized.");
      }
    },
    async login({ commit, dispatch }, credentials) {
      try {
        commit('setLoginError', null);
        const notificationDeniedTime = localStorage.getItem('notificationDeniedTime');
        const denied = localStorage.getItem("dontAskAgainForNotification")
        localStorage.clear();
        if(notificationDeniedTime){
          localStorage.setItem('notificationDeniedTime', notificationDeniedTime);
        }
        if(denied){
          localStorage.setItem('dontAskAgainForNotification', denied);
        }
        localStorage.setItem('remember', credentials.remember);
        sessionStorage.setItem('remember', true); //the same tab user should be able to reload and do other functionalities.
        commit('loggingIn', true);
        let { data } = await api.post(baseUrl + (credentials.otp ? '/auth/login-with-otp' : '/auth/login'), credentials, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        commit('loggedIn', data);
        const userInfo = await dispatch('loadUserDetails');
        commit('loggingIn', false);
        return userInfo;
      }
      catch (e) {
        const errorMessage = e?.response?.data?.message
        // notifyError(MESSAGES.LOGIN_FAILED);
        commit('setLoginError', errorMessage || MESSAGES.LOGIN_FAILED);
        commit('loggingIn', false);
        throw e;
      }
    },

    async loginWithSessionID({ commit, dispatch }, body) {
      try {
        commit('setLoginError', null);
        const notificationDeniedTime = localStorage.getItem('notificationDeniedTime');
        const denied = localStorage.getItem("dontAskAgainForNotification")
        localStorage.clear();
        if(notificationDeniedTime){
          localStorage.setItem('notificationDeniedTime', notificationDeniedTime);
        }
        if(denied){
          localStorage.setItem('dontAskAgainForNotification', denied);
        }
        localStorage.setItem('remember', true);
        sessionStorage.setItem('remember', true); //the same tab user should be able to reload and do other functionalities.
        commit('loggingIn', true);
        let { data } = await api.post(baseUrl + '/partner/authenticate', body, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        commit('loggedIn', data);
        const userInfo = await dispatch('loadUserDetails');
        commit('loggingIn', false);
        return userInfo;
      }
      catch (e) {
        // notifyError(MESSAGES.LOGIN_FAILED);
        commit('setLoginError', MESSAGES.LOGIN_FAILED);
        commit('loggingIn', false);
        throw e;
      }
    },

    async userPortalLoginWithSessionID({ commit, dispatch }, body) {
      try {
        commit('setLoginError', null);
        const notificationDeniedTime = localStorage.getItem('notificationDeniedTime');
        const denied = localStorage.getItem("dontAskAgainForNotification")
        localStorage.clear();
        if(notificationDeniedTime){
          localStorage.setItem('notificationDeniedTime', notificationDeniedTime);
        }
        if(denied){
          localStorage.setItem('dontAskAgainForNotification', denied);
        }
        localStorage.setItem('remember', true);
        sessionStorage.setItem('remember', true); //the same tab user should be able to reload and do other functionalities.
        commit('loggingIn', true);
        let { data } = await api.post(baseUrl + '/partner/switch-portal/authenticate', body, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        commit('loggedIn', data);
        const userInfo = await dispatch('loadUserDetails');
        commit('loggingIn', false);
        // if user prefer to use old admin and not mandated by corporate
        if (!body.useOldAdmin) localStorage.setItem("useNewAdminPortal", "true");
        return userInfo;
      }
      catch (e) {
        // notifyError(MESSAGES.LOGIN_FAILED);
        commit('setLoginError', MESSAGES.LOGIN_FAILED);
        commit('loggingIn', false);
        throw e;
      }
    },

    async goToAdminPortal({ state, getters, commit, dispatch }, body = {}) {
      const {newTab, path, newAdminPortal} = body || {};
      if (!newAdminPortal && !getters.useNewAdmin) return router.push('/management')
      const { sessionID } = await api.get(
          '/partner/switch-portal/create-session-id',
          {
            headers: {
              'ef-skip-refresh': true
            }
          }
      ).then(res => res.data);

      if (!sessionID) {
        Swal.fire({
          icon: 'error',
          title: 'Failed to open admin portal',
          text: '',
          confirmButtonColor: '#73bc44',
          confirmButtonText: 'OK'
        })
      }
      // Construct base URL using USER_PORTAL_URL
      const base = new URL(state.ADMIN_PORTAL_URL);

      // Parse input path or URL
      const inputUrl = path?.startsWith('http') ? new URL(path) : new URL(path || '/dashboards/overview', base);

      // Override domain with USER_PORTAL_URL
      const finalUrl = new URL(base.origin + inputUrl.pathname + inputUrl.search);

      // Set or update sessionID param
      finalUrl.searchParams.set('sessionID', sessionID);

      // Redirect or open in new tab
      if (newTab) {
        window.open(finalUrl.href, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = finalUrl.href;
      }

      return sessionID;
    },

    async signUp({ commit, dispatch }, credentials) {
      commit('setSignUpError', null);
      commit('signUpSuccess', null);
      try {
        commit('signingUp', true);
        const data = await api.post(baseUrl + '/user-detail/sign-up-user', credentials, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        if(credentials && credentials.googleSigUp){
          return await dispatch('googleSSOlogin', credentials);
        }else{
          return await dispatch('login', credentials);
        }
      }
      catch (e) {
        commit('signingUp', false);
        if (e.response.status == 409) {
          commit('setSignUpError', MESSAGES.DUPLICATE_USER_ERROR);
        } else {
          commit('setSignUpError', MESSAGES.RESET_FAILED);
        }
        throw e;
      }
    },

    async signUpWithOTP({ commit, dispatch }, credentials) {
      commit('setSignUpError', null);
      commit('signUpSuccess', null);
      try {
        commit('signingUp', true);
        const data = await api.post(baseUrl + '/user-detail/sign-up-otp-verify', credentials, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        return await dispatch('login', credentials);
      }
      catch (e) {
        commit('signingUp', false);
        if (e.response.status == 409) {
          commit('setSignUpError', MESSAGES.DUPLICATE_USER_ERROR_MOBILE);
        } else {
          commit('setSignUpError', MESSAGES.RESET_FAILED);
        }
        throw e;
      }
    },

    

    async generateSignInOTP({ commit, dispatch }, payload) {
      commit('setLoginError', null);
      try {
        commit('loggingIn', true);
        const data = await api.post(baseUrl + '/user-detail/sign-in-otp', payload, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        return data
      }
      catch (e) {
        commit('loggingIn', false);
        const errorMessage = e?.response?.data?.message

        if(errorMessage){
          commit('setLoginError', errorMessage);
        }        
        else if (e.response.status == 409) {
          commit('setLoginError', MESSAGES.LOGIN_FAILED);
        } else {
          commit('setSignUpError', MESSAGES.LOGIN_FAILED);
        }
        throw e;
      }
    },

    async generateSignUpOTP({ commit, dispatch }, payload) {
      commit('setSignUpError', null);
      commit('signUpSuccess', null);
      try {
        commit('signingUp', true);
        const data = await api.post(baseUrl + '/user-detail/sign-up-otp', payload, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        return data
      }
      catch (e) {
        commit('signingUp', false);
        if (e.response.status == 409) {
          commit('setSignUpError', MESSAGES.DUPLICATE_USER_ERROR_MOBILE);
        } else {
          commit('setSignUpError', MESSAGES.RESET_FAILED);
        }
        throw e;
      }
    },

    async generateMobileOTP({ commit }, payload) {
      try {
        const data = await api.post(baseUrl + '/user-detail/generate-mobile-otp', payload, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        return data
      }
      catch (e) {
        throw e;
      }
    },

    async verifyMobileOTP({ commit }, payload) {
      try {
        const data = await api.post(baseUrl + '/user-detail/verify-mobile-otp', payload, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        return data
      }
      catch (e) {
        throw e;
      }
    },

    async corporateSignUp({ commit, dispatch }, credentials) {
      commit('setSignUpError', null);
      commit('signUpSuccess', null);
      commit('setPromoCodeError', null);
      commit('setAccessCodeError', null);
      try {
        const resp = await api.post(baseUrl + '/user-detail/sign-up-user', credentials, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        if (resp.data.code !== 200) {
          if (resp.data.code === 551) {
            // right now we get 551 error code for both access code and promocode error.
            commit('setPromoCodeError', resp.data.message);
            commit('setAccessCodeError', resp.data.message);
            commit('signUpSuccess', false);
            return;
          } else {
            commit('setSignUpError', resp.data.message);
            commit('signUpSuccess', false);
            return;
          }
        }
        if(credentials.googleSigUp == true){
          return resp.data;
        }
        // return resp.data;
        return await dispatch('login', credentials);
      }
      catch (e) {
        commit('signUpSuccess', false);
        if (e.response.status == 409) {
          commit('setSignUpError', MESSAGES.DUPLICATE_USER_ERROR);
        } else {
          commit('setSignUpError', MESSAGES.RESET_FAILED);
        }
        throw e;
      }
    },

    async loadUserDetails({ commit, dispatch }) {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          return;
        };

        let { data: userInfo } = await api.get(baseUrl + '/user-detail');

        //load menu for user

        let menu = await api.get(baseUrl + '/menu-items');

        commit('setMenuItem', menu.data);

        commit('setUserInfo', userInfo);
        commit('user/profile/setUserGoal', userInfo);


        if(userInfo.unreadNotificationCount){
          commit('setUnreadCount', Number(userInfo.unreadNotificationCount));
        }

        // show popup for promocode expiry
        if (userInfo && userInfo.subscription && !userInfo.subscription.isValid) {
          // promocode query in url, don't show popup
          let promoCode = new URL(document.location).searchParams.has("promocode");
          if (!promoCode) this.dispatch("showPromoCodePopup", {
            title: '<h4>Your subscription has expired!</h4>'
          });
        }
        return userInfo;
      } catch (e) {
        try {
          const token = localStorage.getItem('token');
          if (!token) {
            return;
          };

          let { data: userInfo } = await api.get(baseUrl + '/user-detail');

          //load menu for user

          let menu = await api.get(baseUrl + '/menu-items');

          commit('setMenuItem', menu.data);

          commit('setUserInfo', userInfo);
          commit('user/profile/setUserGoal', userInfo);
          return userInfo;
        }
        catch{
          redirect(e);
          Promise.reject(e);
        };
      };
    },

    async saveAnonymousUser({ commit }, userInfo) {
      let response;
      if (userInfo.unintercepted) {
        response = await axios.create().post(baseUrl + '/user-detail/anonymous-user', userInfo);
      }
      else {
        response = await api.post(baseUrl + '/user-detail/anonymous-user', userInfo);
      }
      userInfo.id = response.data.user;
      commit('loggedIn', response.data);
      commit('setUserInfo', userInfo);
      return response;
    },

    async loadAllTenants({ commit }) {
      commit('setLoading', true);
      const tenants = await api.get(baseUrl + '/tenants');
      commit('tenantList', tenants.data);
    },

    async setSelectedTenant({ commit }, data) {
      commit('setLoading', true);
      await api.put(baseUrl + '/auth/updateAccessToken', { tenantId: data }).then((response) => {
        localStorage.setItem('token', response.data.token);
        commit('setSelectedTenant', data);
        commit('setLoading', false);
      });
    },

    async setFCMToken({ commit }, data) {      
      commit('setFCMToken', data);
    },

    async setUnreadCount({ commit }, data) {      
      commit('setUnreadCount', data);
    },

    async sendResetInstructions({ commit }, email) {
      commit('setResetError', null);
      try {
        let response = await api.post(baseUrl + '/forgot-password/send-mail?email=' + email, { email },
          {
            headers: {
              'ef-skip-refresh': true
            }
          });
        if (response.data.message == 'UnregisteredUser') {
          commit('setResetError', MESSAGES.UNREGISTERED_USER);
          commit('setResetInstructions', false);
        } else {
          commit('setResetInstructions', true);
        }
      }
      catch (e) {
        commit('setResetError', MESSAGES.RESET_FAILED);
        commit('setResetInstructions', false);
      }
    },

    async resetPassword({ commit }, data) {
      commit('setResetError', null);
      try {
        let response = await api.put(baseUrl + '/forgot-password/reset', data,
          {
            headers: {
              'ef-skip-refresh': true
            }
          });
        if (response.data.message == 'success') {
          commit('setPasswordReset', true);
        } else if (response.data.message == 'sameOldPassword') {
          commit("setResetError", MESSAGES.SAME_OLD_PASSWORD);
        }
      }
      catch (e) {
        commit('setResetError', MESSAGES.RESET_FAILED);
        commit('setPasswordReset', false);
      }
    },

    async getFreeVideos({ state, commit }) {
      commit('setLoading', true);
      await api.get(baseUrl + '/free-videos').then((response) => {
        commit('setFreeVideos', response.data);
        commit('setLoading', false);
      });
    },

    async logout({ state, commit }, redirectUrl = '/ef/sign-in') {

      const corp = state.userInfo?.corporate;
      if (corp && corp.redirect_url) {
        redirectUrl = `/${corp.redirect_url}/sign-in`;
      }
      const lang = localStorage.getItem('lang');
      const denied = localStorage.getItem("dontAskAgainForNotification")
      const notificationDeniedTime = localStorage.getItem('notificationDeniedTime');
      localStorage.clear();
      if (lang) {
          localStorage.setItem('lang', lang);
      }
      if(denied){
        localStorage.setItem('dontAskAgainForNotification', denied);
      }
      if(notificationDeniedTime){
        localStorage.setItem('notificationDeniedTime', notificationDeniedTime);
      }
      sessionStorage.setItem("isAccessCodeCancel", "false");
      if (state.refreshTask) {
        clearTimeout(state.refreshTask);
      }
      commit('logout');

      const userInfo = defaultUser[0];
      await store.dispatch('saveAnonymousUser', userInfo);

      await router.push(redirectUrl);
    },

    async googleSSOlogin({ commit, dispatch }, credentials) {
      try {
        commit('setLoginError', null);

        localStorage.clear(); //the same tab user should be able to reload and do other functionalities.

        commit('loggingIn', true);
        let { data } = await api.post(baseUrl + '/auth/loginGoogle', credentials, {
          headers: {
            'ef-skip-refresh': true
          }
        });
        commit('loggedIn', data);
        const userInfo = await dispatch('loadUserDetails');
        commit('loggingIn', false);
        return userInfo;
      }
      catch (e) {
        // notifyError(MESSAGES.LOGIN_FAILED);
        commit('setLoginError', MESSAGES.LOGIN_FAILED);
        commit('loggingIn', false);
        throw e;
      }
    },

    async showPromoCodePopup({ commit, dispatch, state }, data) {
      try {

        window.handleInputKey = function (currentElement, currentIndex, event) {
          const nextElement = document.getElementById(`promoCode-box${currentIndex + 1}`);
          const prevElement = document.getElementById(`promoCode-box${currentIndex - 1}`);
        
          if (event.key === 'Backspace' && currentElement.value === '' && prevElement) {
            // Move focus to the previous input field on Backspace
            prevElement.focus();
          } else if (currentElement.value && nextElement && event.key !== 'Backspace') {
            // Move focus to the next input field when typing a character
            nextElement.focus();
          }
        };

        let promoCode = data?.promoCode || '';
        let backgroundImage = data?.backgroundImage || state.userInfo?.corporate?.config?.popupBackground || null;
        let title = data.title || '<h4>Enter new promo code<sup>*</sup></h4>';
        let existedPromoCode = promoCode.slice(0, 8);
        let diff = Math.max(0, 6 - existedPromoCode.length);
        existedPromoCode += ' '.repeat(diff);
        let htmlString = existedPromoCode.split('').map((val, index) => `
          <input 
            type="text" 
            onkeyup="handleInputKey(this, ${index}, event)" 
            class="swal2-input m-1 form-control" 
            maxlength="1" 
            id="promoCode-box${index}" 
            value="${val}" 
            style="font-size: 1.3rem!important; font-weight: 600!important;" 
          />
        `).join('');
    
        return Vue.swal.fire({
          title: title,
          footer: '',
          html: `<div class="input-group h-100" style="font-size: xx-large;">${htmlString}</div>`,
          input: '',
          inputValue: promoCode,
          inputPlaceholder: 'Enter promo code here...',
          showCloseButton: false,
          showCancelButton: true,
          confirmButtonText: 'Apply',
          showLoaderOnConfirm: true,
          background: `url(${backgroundImage})`,
          didOpen: () => {
            for (let iter = 0; iter < existedPromoCode.length; iter++) {
              let inputElement = Vue.swal.getPopup().querySelector(`#promoCode-box${iter}`);
              if (inputElement && inputElement.value === ' ') {
                inputElement.value = '';
              }
            }
          },
          preConfirm: () => {
            let promoCode = '';
            for (let iter = 0; iter < existedPromoCode.length; iter++) {
              const currentValue = Vue.swal.getPopup().querySelector(`#promoCode-box${iter}`).value;
              promoCode += currentValue;
            }
            promoCode = promoCode.toUpperCase();
            return api.post(baseUrl + '/promo-code/use', { promoCode })
              .then(response => {
                let { data: resData } = response;
                if (resData.code != 200) {
                  throw new Error(resData.message);
                }
                return resData;
              })
              .catch(error => {
                Vue.swal.showValidationMessage(`${error}`);
              });
          },
          allowOutsideClick: false
        }).then(async (result) => {
          if (result.isConfirmed && result.value.code == 200) {
            Vue.swal.fire("Successful", "Promo code applied successfully.", "success");
            await dispatch('loadUserDetails', null);
          }
          return result;
        })
      } catch (e) {
        throw e;
      }
    },
    async sendContactEmail({ commit }, userData) {
      return api.post(baseUrl + '/about-us/send-contact-email', userData);
    },
    async disableTutorialPopup({ commit, state }) {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      localStorage.setItem("userInfo", JSON.stringify({...userInfo, disable_tutorial_popup: true}));
      await api.put(baseUrl + '/user-detail/disable-tutorial-popup');
    }
  },
  modules: {
    b2bClient,
    admin,
    user,
    b2bUser,
    fitClient,
    campaign,
    social,
    dashboard,
    themes,
  },
  strict
});

export default store;
